export const REVIEW_INSTANT_FORMAT = 'MM/DD/YYYY h:mm A [UTC]'

export const EXTRACTION_FIELD_LABELS: Record<string, string> = {
  number: 'Number',
  title: 'Title',
  currency: 'Currency',
  amount: 'Amount',
  incoterm: 'Incoterm',
  effectiveDate: 'Effective date',
  endDate: 'End date',
  notes: 'Notes',
  externalReference: 'Reference',
  externalParentReference: 'Parent reference'
}

export const PROPOSAL_KIND_LABELS: Record<string, string> = {
  purchase_order: 'purchase order',
  invoice: 'invoice',
  operational: 'operational',
  payable: 'payable',
  proof_of_acceptance: 'proof of acceptance',
  attachment: 'attachment',
  information_request: 'information request',
  trader_document: 'upload'
}

export const DOUBT_KIND_LABELS: Record<string, string> = {
  trader_side: 'Which side the trader is on',
  ambiguous_date: 'Which date the page means',
  currency_conflict: 'Conflicting currencies',
  arithmetic_mismatch: 'The figures do not add up',
  figure_choice: 'Which figure this document brings',
  party_mismatch: 'The parties do not match',
  possible_duplicate: 'This may already be in Klear',
  pending_parent: 'The parent is still under review',
  existing_record: 'A record like this already exists',
  tax_unstated: 'Tax is not stated',
  missing_required_value: 'A required value is missing',
  not_import_work: 'This may not be import work',
  non_document: 'This is not a document',
  reference_not_in_klear: 'The reference is not in Klear',
  party_not_on_file: 'The party is not on file',
  party_matched: 'The party was matched to one on file',
  registry_unavailable: 'The registry could not be reached',
  value_normalised: 'A value was normalised',
  sparse_document: 'The page carries little to read',
  provisional_document: 'The page is a quote, sales order or draft',
  date_outside_record_window: 'The record keeps its own date',
  invoices_exceed_purchase_order: 'The invoices total more than the purchase order',
  same_file_on_record: 'The record already holds this file',
  uncosted_copy_on_record: 'The record holds an uncosted copy',
  finalized_record: 'The record keeps its values',
  trader_uncertain: 'The trader is unclear',
  order_missing: 'No order is chosen',
  question: 'Something to decide',
  observation: 'Something to check before funding'
}

export const PROCESSING_STATUS_LABELS: Record<string, string> = {
  processing: 'processing',
  needs_review: 'waiting on you',
  approved: 'queued to create records',
  executing: 'creating records',
  executed: 'filed',
  denied: 'denied',
  superseded: 'replaced by another run',
  failed: 'blocked'
}

export function recordLabel(recordIdDisplay: string | null, orderEventId: number): string {
  return recordIdDisplay ?? `Record ${orderEventId}`
}

export function extractionFieldLabel(field: string): string {
  return EXTRACTION_FIELD_LABELS[field] ?? field
}

export function proposalKindLabel(kind: string): string {
  return PROPOSAL_KIND_LABELS[kind] ?? kind
}

export function proposalKindSentenceLabel(kind: string): string {
  const label = proposalKindLabel(kind)
  return label.charAt(0).toUpperCase() + label.slice(1)
}

export function doubtKindLabel(kind: string): string {
  return DOUBT_KIND_LABELS[kind] ?? kind
}

export function processingStatusLabel(status: string): string {
  return PROCESSING_STATUS_LABELS[status] ?? status.replace(/_/g, ' ')
}
